var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#DDDFED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.999 31.998V43.998C31.999 44.8263 32.6706 45.498 33.499 45.498C34.3274 45.498 34.999 44.8263 34.999 43.998V31.998C34.999 31.1696 34.3274 30.498 33.499 30.498C32.6706 30.498 31.999 31.1696 31.999 31.998Z",
    fill: "#42424E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 30.498C40.3284 30.498 41 31.1696 41 31.998V43.998C41 44.8263 40.3284 45.498 39.5 45.498C38.6716 45.498 38 44.8263 38 43.998V31.998C38 31.1696 38.6716 30.498 39.5 30.498Z",
    fill: "#42424E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 23H50.5C51.3283 23 52 23.6716 52 24.5C52 25.3284 51.3283 26 50.5 26H48.8425L46.5838 46.3283C46.1617 50.1266 42.9514 53 39.1297 53H31.8702C28.0486 53 24.8381 50.1266 24.4161 46.3283L22.1574 26H20.5C19.6716 26 19 25.3284 19 24.5C19 23.6716 19.6716 23 20.5 23H29.5C29.5 19.6863 32.1863 17 35.5 17C38.8137 17 41.5 19.6863 41.5 23ZM35.5 20C33.8432 20 32.5 21.3432 32.5 23H38.5C38.5 21.3432 37.1569 20 35.5 20ZM25.1759 26L27.3978 45.9968C27.651 48.2759 29.5773 50 31.8702 50H39.1297C41.4227 50 43.3489 48.2759 43.6021 45.9968L45.8242 26H25.1759Z",
    fill: "#42424E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c818ee26d7674ac632ce06544d41c3c2.svg";
export { ForwardRef as ReactComponent };